module.exports = __webpack_public_path__ + "img/nagios.baaf4d18.png";